import { z } from 'zod';
import { IsoDateSchema } from './common.js';
export const TOP_N_OPTIONS = [5, 10, 15, 20, 25, 30];
export const TERRITORIES = ['WW', 'US', 'EX'];
export const CATALOGUE_YEARS = [2016, 2017, 2018, 2019, 2020, 2021, 2022];
export const BASES = ['LTM', 'L3Y', 'L5Y', 'YTD21'];
export const TopNSchema = z.coerce.number().pipe(z.union(TOP_N_OPTIONS.map((n) => z.literal(n))));
export const TerritorySchema = z.enum(TERRITORIES);
export const CatalogueYearSchema = z.coerce
    .number()
    .pipe(z.union(CATALOGUE_YEARS.map((y) => z.literal(y))));
export const BasisSchema = z.enum(BASES);
export const DEFAULT_SELECTORS = { topN: 10, territory: 'WW', cat: 2018, basis: 'LTM' };
/** Query-string selectors shared by breakdown, composition and exports. */
export const SelectorsQuerySchema = z.object({
    topN: TopNSchema.default(DEFAULT_SELECTORS.topN),
    territory: TerritorySchema.default(DEFAULT_SELECTORS.territory),
    cat: CatalogueYearSchema.default(DEFAULT_SELECTORS.cat),
    basis: BasisSchema.default(DEFAULT_SELECTORS.basis),
    /** Optional anchor override; must not be later than the discovered anchor. */
    asOf: IsoDateSchema.optional(),
});
export const SelectorsSchema = SelectorsQuerySchema.omit({ asOf: true });
export const AsOfQuerySchema = z.object({ asOf: IsoDateSchema.optional() });
//# sourceMappingURL=selectors.js.map